import { type Action, FilterActionTypes, action } from "easy-peasy";

import DEFAULT_SESSION from "./default";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<SessionModel>) =>
  createLogEffect<SessionModel>("SESSION", property, false);

export type SessionModel = {
  value: SessionType;
  valueOnChange: LogEffect<SessionModel>;
  set: Action<SessionModel, SessionType>;
};

const sessionModel: SessionModel = {
  value: DEFAULT_SESSION,
  valueOnChange: logEffect("value"),
  set: action((state, payload) => {
    if (payload !== state.value) {
      state.value = payload;
    }
  }),
};

export default sessionModel;
